<template>
  <div class="cube-word-template-render-upload">
    <el-upload
      v-bind="$attrs"
      ref="upload"
      class="uploader"
      :show-file-list="false"
      :on-success="uploadSuccess"
      :action="computedAction"
      :before-upload="beforeUploadApp"
    >
        <div v-if="imageUrl">
          <img  :src="imageUrl" class="upload" />
              <span
              class="el-upload-list__item-delete"
              @click.stop="beforeRemove"
            >
              <i class="el-icon-close"></i>
            </span>
        </div>

      <i v-else class="el-icon-plus uploader-icon"></i>
    </el-upload>
  </div>
</template>
<script>
export default {
  name: 'TemplateFormUpload',
  props: {
    value: {
      type: String,
      required: true
    },
    labelItem: {
      type: Object,
      required: () => {
        return {
          id: null,
          name: null
        }
      }
    }
  },
  data() {
    return {
      imageUrl: '',
      fileHistory: {}
    }
  },
  computed: {
    computedAction() {
      const option = this.labelItem.option
      if (option && option.action) {
        return option.action
      } else {
        return ''
      }
    }
  },
  watch: {
    value: {
      handler(nv) {
        this.imageUrl = nv
      },
      immediate: true
    }
  },
  methods: {
    async beforeRemove() {
      await this.$confirm(`确定移除该图片？`)
      this.imageUrl = ''
      this.$emit('input', this.imageUrl)
      return
    },
    uploadSuccess({ file, data }, fileObj) {
      if (!data) return
      this.fileHistory = data
      this.imageUrl = data.fileUrl
      this.$emit('input', this.imageUrl)
      this.$emit('upload-success', { item: this.labelItem, data: data })
    }
  }
}
</script>
<style>
.cube-word-template-render-upload{
  .uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.uploader .el-upload:hover {
  border-color: #409eff;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.upload {
  width: 178px;
  height: 178px;
  display: block;
}
.el-upload-list__item-delete{
  top:5px;
  right:10px;
  display:block;
  transform: scale(2);
}
}
</style>
